<script setup>
import { computed } from "vue";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";

import PartnerLevelLogoComponent from "@/components/common/PartnerLevelLogoComponent.vue";
import PartnerLevelCountriesListComponent from "@/components/common/PartnerLevelCountriesListComponent";

const { t } = useI18n({});

const props = defineProps({
  companyName: {
    type: String,
    default: "",
  },
  isSapPlatinumPartner: {
    type: Boolean,
    default: false,
  },
});

const store = useStore();
const platinumCountries = computed(() => store.state.partnerProfile.profileData.uvarPlatinumCountries);

function getCompanyName() {
  return { company: props.companyName };
}
function platinumDescriptionText() {
  return props.isSapPlatinumPartner
    ? t("sap.platinum.partner.description.text", getCompanyName())
    : t("sap.platinum.partner.country.description.text", getCompanyName());
}

function beforeCountryText() {
  return platinumCountries.value.length === 1
    ? t("sap.platinum.partner.countries.text.single", getCompanyName())
    : t("sap.platinum.partner.countries.text", getCompanyName());
}
</script>

<template>
  <PartnerLevelLogoComponent partnerLevelType="Platinum" />
  <h4 class="HeadingMediumXXXS-size flex justify-center my-4" automation-id="profileRecognitionModal-logoText">
    {{ t("sap.platinum.partner") }}
  </h4>
  <p :class="{ 'mb-6': !props.isSapPlatinumPartner }" automation-id="profileRecognitionModal-description">
    {{ platinumDescriptionText() }}
  </p>
  <p v-if="!props.isSapPlatinumPartner" automation-id="profileRecognitionModal-countryDescription">
    <span v-html="beforeCountryText()"></span>
  </p>
  <PartnerLevelCountriesListComponent :countriesList="platinumCountries" />
</template>
